var FIELD_NAME_MAP = {
    name: "Nome",
    gender: "Sexo",
    hour: "Hora de nascimento",
    minute: "Minuto de nascimento",
    year: "Ano de nascimento",
    month: "Mês de nascimento",
    day: "Dia de nascimento",
    city: "Local de nascimento",

    numerologyProfileName: "Nome Completo"
};

var PRODUCT_STATUS = {
    PROFILE_NOT_SELECTED: 1,
    PROFILE_SELECTED: 2,
    GENERATED: 3
};

var PRODUCT_TYPE = {
    MINI: 1,
    COMPLETE: 2
};
